// Helper di formattazione per valori testuali provenienti dal backend.
// Alcuni campi (es. Tunnel_Status.htmlResult) contengono HTML generato dai
// workflow: qui viene convertito in testo leggibile prima di finire in una
// cella, in un tooltip o in un badge.

const HTML_TAG_REGEX = /<[a-z][\s\S]*>/i

const ENTITY_MAP: Record<string, string> = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'"
}

/**
 * Converte una stringa HTML in testo semplice.
 * - `<br>` e la chiusura di blocchi/righe diventano newline
 * - i tag vengono rimossi
 * - le entita' piu' comuni vengono decodificate
 * - spazi e righe vuote consecutive vengono compattati
 */
export function stripHtml (value: string | null | undefined): string {
  if (value == null) {
    return ''
  }
  const text = String(value)
  if (!HTML_TAG_REGEX.test(text)) {
    return text
  }
  const withoutTags = text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|tr|li|h[1-6])>/gi, '\n')
    .replace(/<[^>]*>/g, ' ')
  return Object.entries(ENTITY_MAP)
    .reduce((result, [entity, replacement]) => result.split(entity).join(replacement), withoutTags)
    .replace(/[ \t]+/g, ' ')
    .replace(/\n\s*\n+/g, '\n')
    .trim()
}

/** True se il valore contiene markup HTML. */
export function containsHtml (value: unknown): boolean {
  return typeof value === 'string' && HTML_TAG_REGEX.test(value)
}
